import { render, staticRenderFns } from "./ext-checkbox.vue?vue&type=template&id=7e5fd837"
import script from "./ext-checkbox.vue?vue&type=script&lang=js"
export * from "./ext-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports